<div [ngClass]="iconClass">
  <mat-icon class="ui-icon d-flex" [svgIcon]="icon()" [attr.aria-label]="description()" [ngStyle]="svgStyles()" />
</div>
